// Can supply / Missing tab switch plus the matching table for the active tab.
// The active tab is owned by the caller (it resets per run); every other prop
// (corrections, editingRow, onEditRow, onCorrect, documentUrl, documentName,
// catalogProducts) is passed straight through to both tables.
import ResultTabs from "./ResultTabs";
import CanSupplyTable from "./CanSupplyTable";
import MissingTable from "./MissingTable";
import { MATCHING_TAB, matchingResultTabs } from "./utils";

export default function MatchingResults({ report, activeTab, onTabChange, ...tableProps }) {
  return (
    <>
      <ResultTabs
        tabs={matchingResultTabs(report)}
        active={activeTab}
        onChange={onTabChange}
        label="Matching results"
      />
      {activeTab === MATCHING_TAB.SUPPLY && (
        <CanSupplyTable results={report.can_supply || []} {...tableProps} />
      )}
      {activeTab === MATCHING_TAB.MISSING && (
        <MissingTable results={report.missing || []} {...tableProps} />
      )}
    </>
  );
}
